import { useState, useEffect } from "react";
import { workshopApi } from "../../../services/workshopApi";

/**
 * Custom hook to fetch featured workshops
 *
 * @param {number} limit - Number of featured workshops to fetch
 * @returns {Object} { featuredWorkshops, loading, error, refetch }
 */
function useFeaturedWorkshops(limit = 6) {
  const [featuredWorkshops, setFeaturedWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFeatured = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await workshopApi.getFeaturedWorkshops(limit);

      if (response.success) {
        setFeaturedWorkshops(response.data.workshops || []);
      } else {
        setError(
          new Error(response.message || "Failed to fetch featured workshops")
        );
      }
    } catch (err) {
      setError(err);
} finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeatured();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  return {
    featuredWorkshops,
    loading,
    error,
    refetch: fetchFeatured,
  };
}

export default useFeaturedWorkshops;
